<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                白色污染主要有哪些成分
            </div>
            <div class="content">
                <p class="bold">聚乙烯：</p>
                <p class="indent">聚乙烯是乙烯经加成聚合反应制得的一种热塑性树脂。根据聚合条件不同，可得到相对分子量从一万几百万不等的聚乙烯。聚乙烯是略带白色的颗粒或粉末，半透明状，无毒无味，化学稳定性好，能耐酸碱腐蚀。商业上将聚乙烯分为低、中、高密度。一般用于包装的主要是不加增塑剂的低密度(0.92g／cm3－0.93 g／cm3)
                </p>
                <p class="bold">聚丙烯：</p>
                <p class="indent">相对分子量在8万—20万之间。聚丙烯主链有一个甲基侧链。如果甲基全部分布在一侧称为等规聚丙烯；如果甲基有规则地分布在主链两侧，称为间规聚丙烯；如果甲基无规则地分布在主链上，称无规聚丙烯。聚丙烯通常是半透明固体，无味无毒，密度（0．90g／cm3—0．91g／cm3），机械强度比聚乙烯高，耐热性好。三种聚丙烯中，以等规聚丙烯产量最大。采用三氯化钛—氯二乙基铝为催化剂，在加氢饱和的汽油中使丙烯聚合，得到等规聚丙烯。</p>
                <p class="bold">聚氯乙烯：</p>
                <p class="indent">相对分子质量5万一12万，聚氯乙烯通过游离基加成聚合反应生成高聚物，属热塑性树脂。无定型白色粉末，无固定熔点，密度为（1．35g／cm3—1．45g／cm3），具有较好的化学稳定性。熔于环乙酮，氯苯，二甲基甲酰胺，甲苯—丙酮混合溶剂等。</p>
                <p class="bold">聚苯乙烯：</p>
                <p class="indent">生产方法：本体聚合法，悬浮聚合法，乳液聚合法．这里介绍本体聚合法。在苯乙烯单体中加入引发剂和少量添加剂，现在预聚釜中进行低温聚合，制取预聚物，再转入聚合塔中高温加热，分段维持一定温度，反应结束即将熔融状聚苯乙烯挤出成条，在水中冷却硬化，切粒包装。</p>
                <p class="indent">以上是“白色污染”的主要成份，另外，在这些污染物中，还加入了增塑剂，发泡剂，热稳定剂，抗氧化剂等。</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "InitiativeView"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
        }
    }
</style>